<div class="heading-row-line"> <a (click)="navigateToValidationsummary()" class="view-more-link">
        Click Here
    </a> to view Validation Summary</div>
<table class="table table-hover align-middle">
    <thead>
        <tr>
            <th>Status</th>
            <th>Rule</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of (validationSummaryItem$ | async)?.data; let i = index">
            <td>
                <app-validation-icon [typeName]="item.isInFeedbackUpdatedState ? 'UPDATED' : item.status">
                </app-validation-icon>
                {{
                item.isInFeedbackUpdatedState
                ? 'Feedback Updated'
                : (item.status === 'OK' ? 'Successful' : 'Warning')
                }}
            </td>
            <td>{{ item.ruleName }}</td>
        </tr>
        <tr>
    </tbody>
</table>
